import { useMemo } from 'react';
import { useDi, API_BASE_URL } from '../../app/providers/DiProvider';
import { AccountApi } from './account.api';

/** Resolves the AccountApi client from the DI container (base URL comes from env). */
export function useAccountApi(): AccountApi {
  const di = useDi();
  return useMemo(() => new AccountApi(di.resolve(API_BASE_URL)), [di]);
}
